import { render, staticRenderFns } from "./StatusBookKeeping.vue?vue&type=template&id=b550b1c8&"
import script from "./StatusBookKeeping.vue?vue&type=script&lang=js&"
export * from "./StatusBookKeeping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports